<template>
    <div ref="listWrap" class="list agreement_list" @click="markInteraction" @focusin="markInteraction" @focusout="onFocusout($event)"
         v-clickoutside="changeToViewerAll" tabindex="-1" style="position:relative; outline: none">
        <template v-if="isActiveEditor || isFirstActive">
            <div :style="{
            fontSize: '12px',
            lineHeight: '12px',
            color: '#808080'
        }">※ 모든 동의문은 자동으로 '필수 동의 항목'으로 적용됩니다.
            </div>
            <EnrolmentAgreementEditor/>
        </template>
        <EnrolmentAgreementViewer v-else :question-index="0" @changeActiveEditor="onChangeActive"/>
    </div>
</template>
<script>
import {mapFields, mapMultiRowFields} from 'vuex-map-fields';
import {ADD_QUESTION} from '@/common/store/modules/enrolment/editor.js';
import {mapActions} from 'vuex';
import {
    LIST_CHANGE,
    STOP_LIST_CHANGE,
} from '@/common/store/modules/common/editor/questionList.js';
import EnrolmentAgreementEditor from '@iamteacherpc/components/editor/EnrolmentAgreementEditor.vue';
import EnrolmentAgreementViewer from '@iamteacherpc/components/editor/EnrolmentAgreementViewer.vue';
import Clickoutside from 'element-ui/lib/utils/clickoutside';

export default {
    name: 'EnrolmentEditorAgreementList',
    components: {EnrolmentAgreementViewer, EnrolmentAgreementEditor},
    directives: {Clickoutside},

    data() {
        return {
            interactionOnce: false,
            isFirstActive: true,
            isActiveEditor: false,
        };
    },

    computed: {
        ...mapMultiRowFields('enrolment', ['form.agreements']),
        ...mapFields('enrolment', {
            isStopListChange: 'options.stopListChange',
        }),
    },

    methods: {
        ...mapActions('enrolment', {
            storeAddQuestion: ADD_QUESTION,
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
        }),

        markInteraction() {
            this.interactionOnce = true;
        },
        onChangeActive() {
            this.isActiveEditor = true;
        },
        onFocusout(event) {
            if (event.relatedTarget && this.$refs.listWrap !== event.relatedTarget && !this.$refs.listWrap.contains(event.relatedTarget)) {
                this.changeToViewerAll();
            }
        },
        changeToViewerAll() {
            if (this.interactionOnce && !this.isStopListChange) {
                this.isFirstActive = false;
                this.isActiveEditor = false;
            }
        },
        setActiveEditor() {
            this.isFirstActive = false;
            this.isActiveEditor = true;
        },
    },
    mounted() {
        this.$eventBus.$on(['parentClick', 'parentFocus'], this.changeToViewerAll);
    },

    beforeDestroy() {
        this.$eventBus.$off(['parentClick', 'parentFocus'], this.changeToViewerAll);
    },
};
</script>

<style scoped>

</style>
